export * from "ce/api/UserApi";
import { UserApi as CE_UserApi } from "ce/api/UserApi";
import type { AxiosPromise } from "axios";
import Api from "api/Api";
import type { ApiResponse } from "api/ApiResponses";
export interface FetchSamlMetadataPayload {
  isEnabled: boolean;
  importFromUrl?: string;
  importFromXml?: string;
  configuration?: {
    singleSignOnServiceUrl: string;
    signingCertificate: string;
    emailField: string;
  };
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  claims?: Record<string, any>;
}

export interface AdminCentralEntry {
  id: string;
  severity: "info" | "warning" | "error";
  title: string;
  description: string;
  status: string;
  details: Array<{
    label: string;
    value: string;
  }>;
  items: Array<{
    id: string;
    title: string;
    subtitle: string;
    details: Array<{
      label: string;
      value: string;
    }>;
  }>;
  itemsLabel?: string;
  documentationUrl?: string;
}

class UserApi extends CE_UserApi {
  static fetchSamlMetadataURL = "/v1/admin/sso/saml";
  static adminCentralURL = "v1/admin/central";

  static async fetchSamlMetadata(
    payload: FetchSamlMetadataPayload,
  ): Promise<AxiosPromise<ApiResponse>> {
    return Api.put(UserApi.fetchSamlMetadataURL, payload);
  }

  static async fetchAdminCentral(): Promise<
    AxiosPromise<ApiResponse<AdminCentralEntry[]>>
  > {
    return Api.get(UserApi.adminCentralURL);
  }
}

export default UserApi;
